import React from "react";
import { useTranslation } from "react-i18next";

const TableHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-4 gap-10 text-white font-bold min-w-[100vh] xl:min-w-0">
      {[t("nav_projects"), t("duration_of_project"), t("nav_value")].map(
        (heading, index) => (
          <div
            className={`${
              index === 0 ? "col-span-2" : "col-span-1"
            } min-w-[200px] xl:min-w-0`}
            key={heading}
          >
            <p className="text-secondary border-b-[3px] border-[#8b8b8b] font-medium text-2xl capitalize">
              {heading}
            </p>
          </div>
        )
      )}
    </div>
  );
};

const OnGoingProjects = ({ data }) => {
  return (
    <div className="px-10 lg:px-20 pb-32 bg-black overflow-x-scroll lg:overflow-x-auto border-b">
      <div className="min-w-[1200px] xl:min-w-0">
        <TableHeader />

        {data?.length ? (
          data.map(
            (
              { project_name, duration_of_project, project_value, id },
              index
            ) => (
              <div
                key={id || index} // Use `id` if available, fallback to `index`
                className="grid grid-cols-4 gap-10 text-gray-300 mb-4 mt-2"
              >
                {/* First column spans 2 columns */}
                <div className="col-span-2 min-w-[200px] xl:min-w-0">
                  {project_name}
                </div>
                <div className="min-w-[200px] xl:min-w-0">
                  {duration_of_project}
                </div>
                <div className="min-w-[200px] xl:min-w-0">{project_value}</div>
              </div>
            )
          )
        ) : (
          <div className="text-gray-400 mt-4 text-center">
            <p>No projects available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnGoingProjects;
